
<template>
<v-card>
  <Cabecera 
    v-if="!incrustado" 
    tipoModuloActual="validacionDocumentacion"
    :incrustado="incrustado"/>
  <StepperPortal v-if="!incrustado" tipoModuloActual="validacionDocumentacion" />
  <v-container fluid>
    <o-big-title v-if="incrustado">
      {{titulo}}
    </o-big-title>
    <DocumentacionTerminado 
      v-if="incrustado"
      :cargandoExterior="cargandoExterior"
      :incrustado="incrustado"
      :tipo="'validacionDocumentacion'"
      @continuar="terminar"
    />
    <div v-else>
      <v-form ref="form" v-model="valid">
      <v-stepper
        class="proceso-pago elevation-0"
        v-model="step"
        :alt-labels="!$vuetify.breakpoint.xsOnly"
        :vertical="$vuetify.breakpoint.xsOnly"
        id="stepperVal"
      >
        <component 
          v-if="modulosStepper.length > 1"
          :is="!$vuetify.breakpoint.xsOnly ? 'v-stepper-header' : 'v-flex'"
          class="elevation-0"
          :class="$vuetify.breakpoint.xsOnly ? 'proceso-pago-header' : ''"
        >
          <template
            v-for="(item, index) in modulosStepper"
          >
            <v-stepper-step
              :editable="editable(item)"
              :key="'step' + item.tipo"
              :edit-icon="$vuetify.icons.complete"
              :complete="step > index + 1"
              :step="index + 1"
            >
              <span :class="{'text-xs-center' : !$vuetify.breakpoint.xsOnly}">{{getNombreModulo(item.tipo)}}</span>
            </v-stepper-step>
            <v-divider :key="'divider' + item.tipo" v-if="index + 1 < modulosStepper.length" :vertical="$vuetify.breakpoint.xsOnly"/>
          </template>
        </component>
        <v-stepper-items>
          <template
            v-for="(item, index) in modulosStepper"
          >
          <v-stepper-content :key="'content'+item.tipo" :step="index + 1" style="transition:0.1s !important">
            <v-container>
              <BaseKyc
                v-if="item.tipo === 'kyc'"
                class="mb-3"
                :compradores.sync="compradores"
                :expansion.sync="expansion"
                :incrustado="false"
                :cargandoExterior="cargandoExterior"
                :waitingForLoad="waitingForLoad"
                :mostrarDescripcion="true"
                :tipo="'validacionDocumentacion'"
              />
              <v-layout v-else>
                <v-flex>
                  <BaseDocumentacion 
                    :tipo="'validacionDocumentacion'"
                    :compradores.sync="compradores"
                    :mostrarDocExtra="validacionPasos.documentacion.validarTodo"
                  />
                </v-flex>
              </v-layout>
              <v-layout column>
                <o-medium-title>
                  {{$t('reservas.validacionDoc.validacion')}}
                </o-medium-title>
                <o-base-text :marginBottom="false" class="mb-1">
                  {{textoValidarPaso(item.tipo)}}
                </o-base-text>
                <v-radio-group
                  v-model="validacionPasos[item.tipo].validarTodo"
                  hide-details
                  :class="['pl-2', item.tipo === 'kyc' || validacionPasos[item.tipo].validarTodo !== false  ? 'mb-2' : '']"
                >
                  <v-layout>
                    <v-radio
                      color="primary"
                      :label="$t('reservas.validacionDoc.si')"
                      :value="true"
                      class="mb-0"
                    />
                    <v-radio
                      selected
                      color="primary"
                      :label="$t('reservas.validacionDoc.no')"
                      :value="false"
                      class="mb-0"
                    />
                  </v-layout>
                </v-radio-group>
                <v-slide-y-transition>
                  <v-layout v-if="validacionPasos[item.tipo].validarTodo === false" column mb-2>
                    <o-base-text :marginBottom="false">
                      {{$t('reservas.validacionDoc.addComentarios')}}
                    </o-base-text>
                    <v-textarea
                      v-model="validacionPasos[item.tipo].textoValidacion"
                      auto-grow
                    />
                  </v-layout>
                </v-slide-y-transition>
              </v-layout>
            </v-container>
          </v-stepper-content>
          </template>
        </v-stepper-items>
      </v-stepper>
      </v-form>
      <v-layout 
        v-if="!incrustado"
        justify-space-around
      >
        <v-btn 
          large
          color="primary"
          :disabled="waitingForLoad || cargandoExterior"
          :loading="waitingForLoad || cargandoExterior"
          @click="validarPaso()"
        >
          {{$t('reservas.validacionDoc.continuar')}}
        </v-btn>
      </v-layout>
    </div>
  </v-container>
</v-card>
  
</template>

<script>
import DocumentacionTerminado from '@/components/reservas/documentacion/DocumentacionTerminado'
import BaseDocumentacion from '@/components/reservas/documentacion/BaseDocumentacion'
import MixinComprador from '@/mixins/comprador'
import MixinEstadoKyc from '@/mixins/estadosReserva/estadoKyc'
import MixinDocumentacion from '@/mixins/documentacion'
import rules from '@/mixins/rules'
import Cabecera from '@/components/Cabecera'
import BaseKyc from '@/components/reservas/comprador/BaseKyc'
import { mapGetters, mapActions } from 'vuex'
import StepperPortal from '@/components/StepperPortal'

export default {
  mixins: [rules, MixinComprador, MixinEstadoKyc, MixinDocumentacion],
  props: {
    incrustado: {
      type: Boolean,
      default: false
    },
    cargandoExterior: {
      type: Boolean,
      default: false
    },
    actual: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      compradoresCreated: false,
      cambiadoData: false,
      step: 0,
      waitingForLoad: false,
      compradores: [],
      expansion: [],
      valid: false,
      validacionPasos: {
        kyc: {
          validarTodo: null,
          textoValidacion: ''
        },
        documentacion: {
          validarTodo: null,
          textoValidacion: '',
          habilitarSubidaExtra: false
        }
      },
      kycEstaValidado: false
    }
  },
  components: {
    DocumentacionTerminado, BaseKyc, BaseDocumentacion, Cabecera, StepperPortal
  },
  async created () {
    this.compradoresCreated = false
    this.inicializarCompradores()
    this.compradores.forEach(comprador => {
      let documentacion = []
      if (!this.getGenerarContratoKyc) {
        comprador.validacionKyc.datosRepresentanteValidos = true
      }
      // Insertar documentos que faltan con null
      this.carpetas.forEach(carpeta => {
        let documentos = comprador.documentacion.filter(d => d.carpetaId === carpeta.id)
        documentacion.push({
          carpetaId: carpeta.id,
          tipoObjetoId: carpeta.tipoObjetoId,
          objetoId: comprador.id,
          carpeta: carpeta,
          documento: documentos.map(doc => {
            return {
              extension: doc.documento.extension,
              id: doc.documento.id,
              mime: doc.documento.mime,
              nombre: doc.documento.nombre,
              descripcionDocumento: doc.descripcionDocumento,
              validado: doc.validado ? true : false
            }
          }),
          validado: this.estadoValidacionDocumento(documentos, true, carpeta)
        })
      })
      comprador.documentacion = documentacion
      comprador.documentacion = this.documentacionFiltrada(comprador)
      this.validacionPasos.documentacion.habilitarSubidaExtra = this.documentacionExtra != null
    })
    this.$nextTick(() => {
      this.compradoresCreated = true
    })
  },
  computed: {
    ...mapGetters({
      modulos: 'modulosOrdenes/modulos/getAll',
      inmuebleStore: 'promociones/inmuebles/getById',
      promocionStore: 'promociones/getById',
      carpetasStore: 'carpetas/getAll',
      reserva: 'reservas/_id/getActual',
      getGenerarContratoKyc: 'modulosOrdenes/getGenerarContratoKyc'
    }),
    titulo () {
      return this.getTexto('modulos.validacionDocumentacion' + (this.reserva.cod_tipo_operacion === 'ALQ' ? 'Alquiler' : ''))
    },
    inmueble () {
      return this.inmuebleStore(this.reserva.codigoActivo, this.reserva.codigoPromocion)
    },
    promocion () {
      return this.promocionStore(this.reserva.codigoPromocion)
    },
    carpetas () {
      return this.carpetasStore
    },
    modulosStepper () {
      let retorno = this.modulos.filter(x => (x.tipo === 'kyc' || x.tipo === 'documentacion'))
      return retorno
    },
    todosDocumentosValidados () {
      for (let i = 0; i < this.compradores.length; i++) {
        if (!this.moduloOrden.aportarDocumentosFormaFlexible) {
          if (this.compradores[i].documentacion.some(x => !x.validado)) {
            return false
          }
        } else {
          if (this.compradores[i].documentacion[0].documento.some(x => !x.validado)) {
            return false
          }
        }
      }
      return true
    },
    cantidadDocumentosNoValidados () {
      let cont = 0
      for (let i = 0; i < this.compradores.length; i++) {
        this.compradores[i].documentacion.forEach(x => {
          if (!x.validado) {
            cont++
          }
        })
      }
      return cont
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      rechazarKyc: 'compradores/rechazarKyc',
      validarDocumentacion: 'documentacion/validarDocumentacion'
    }),
    getNombreModulo(tipo) {
      return this.getTexto('modulos.' + tipo + (this.reserva.cod_tipo_operacion === 'ALQ' ? 'Alquiler' : ''))
    },
    editable (item) {
      if (item.tipo === 'kyc' && this.step === 2) {
        return true
      } else if (item.tipo === 'documentacion' && this.step === 1 && this.kycEstaValidado) {
        return true
      } else {
        return false
      }
    },
    terminar (terminar = true) {
      this.$emit('cambiado', false)
      this.$emit('terminado', terminar)
    },
    capitalize (word) {
      return word.charAt(0).toUpperCase() + word.slice(1)
    },
    textoValidarPaso (tipo) {
      return tipo === 'kyc'
        ? (this.reserva.cod_tipo_operacion === 'VTA' ? this.$t('reservas.validacionDoc.validaDatosComprador') : this.$t('reservas.validacionDoc.validaDatosArrendatario'))
        : (this.reserva.cod_tipo_operacion === 'VTA' ? this.$t('reservas.validacionDoc.validaDatosEnviadosComprador') : this.$t('reservas.validacionDoc.validaDatosEnviadosArrendatario'))
    },
    async validarPaso () {
      switch (this.step) {
        case 1:
          await this.validarPasoKyc()
          break
        case 2:
          await this.validarPasoDocumentacion()
          break
        default:
          break
      }
    },
    async validarPasoKyc () {
      if (this.validacionPasos['kyc'].validarTodo === null) {
        this.addAlert({texto: this.$t('reservas.validacionDoc.kycValido'), color: 'error'})
        return
      } else if (this.validacionPasos['kyc'].validarTodo) {
        if (this.compradores.some(x => !this.compradorEstaValidado(x))) {
          this.addAlert({texto: this.$t('reservas.validacionDoc.validaKycSeccion'), color: 'error'})
          return
        }
      } else if (!this.validacionPasos['kyc'].validarTodo) {
        if (!this.compradores.some(x => !this.compradorEstaValidado(x))) {
          this.addAlert({texto: this.$t('reservas.validacionDoc.rechazarKyc'), color: 'error'})
          return
        }
        if (this.validacionPasos['kyc'].textoValidacion === '') {
          this.addAlert({texto: this.$t('reservas.validacionDoc.addComentario'), color: 'error'})
          return
        }
      }
      try {
        this.waitingForLoad = true
        if (!this.validacionPasos['kyc'].validarTodo) {
          await this.rechazarKyc({
            id: this.reserva.id,
            validacion: {
              validado: this.validacionPasos['kyc'].validarTodo,
              textoValidacion: this.validacionPasos['kyc'].textoValidacion
            },
            compradores: this.compradores.map(x => this.formatearCompradorParaValidar(x, false))
          })
          this.terminar(true)
          this.addAlert({texto: this.$t('reservas.validacionDoc.validacionNegativa'), color: 'success'})
        } else {
          this.step++
          this.kycEstaValidado = true
          setTimeout( () => {
            this.$vuetify.goTo('#stepperVal')
          }, 50)
        }
        this.waitingForLoad = false
      } catch (error) {
        this.waitingForLoad = false
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    },
    async validarPasoDocumentacion () {
      if (this.validacionPasos['documentacion'].validarTodo === null) {
        this.addAlert({texto: this.$t('reservas.validacionDoc.indicaNegativa'), color: 'error'})
        return
      } else if (this.validacionPasos['documentacion'].validarTodo) {
        if (!this.todosDocumentosValidados) {
          this.addAlert({texto: this.$t('reservas.validacionDoc.todosValido'), color: 'error'})
          return
        }
      } else if (!this.validacionPasos['documentacion'].validarTodo) {
        if (this.validacionPasos['documentacion'].textoValidacion === '') {
          this.addAlert({texto: this.$t('reservas.validacionDoc.rechazaAddComentario'), color: 'error'})
          return
        } else {
          if (this.todosDocumentosValidados && (this.moduloOrden.aportarDocumentosFormaFlexible || this.documentacionExtra)) {
            this.addAlert({texto: this.$t('reservas.validacionDoc.unDocNoValido'), color: 'error'})
            return
          }
        }
      }
      try {
        this.waitingForLoad = true
        await this.validarDocumentacion({
          id: this.reserva.id,
          validacionDocumentacion: {
            validado: this.validacionPasos['documentacion'].validarTodo,
            textoValidacion: this.validacionPasos['documentacion'].textoValidacion,
            habilitarSubidaExtra: this.validacionPasos['documentacion'].habilitarSubidaExtra
          },
          validacionKyc: {
            validado: this.validacionPasos['kyc'].validarTodo,
            textoValidacion: this.validacionPasos['kyc'].textoValidacion
          },
          titularId: this.getTitular.id,
          compradores: this.compradores.map(x => this.formatearCompradorParaValidar(x, true))
        })
        this.terminar(true)
        this.addAlert({texto: this.$t('general.misc.datosGuardadosExito'), color: 'success'})
        this.waitingForLoad = false
      } catch (error) {
        this.waitingForLoad = false
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    },
    // Formatea los documentos de los compradores
    formatearCompradorParaValidar (x, validarDocumentacion) {
      let documentacionComprador = []
      if (validarDocumentacion) {
        x.documentacion.forEach(doc => {
          doc.documento.forEach(archivo => {
            documentacionComprador.push({
              id: archivo.id,
              validado: !this.moduloOrden.aportarDocumentosFormaFlexible ? doc.validado : archivo.validado
            })
          })
        })
      }
      return {
        id: x.id,
        titular: x.titular,
        datosCompradorValidos: x.validacionKyc.datosCompradorValidos,
        datosRepresentanteValidos: x.validacionKyc.datosRepresentanteValidos,
        documentacion: documentacionComprador
      }
    }
  },
  watch: {
    compradores: {
      deep: true,
      handler () {
        if (this.step === 1) {
          this.kycEstaValidado = false
        }
        if (this.compradoresCreated && !this.cambiadoData) {
          this.cambiadoData = true
          this.$emit('cambiado', this.cambiadoData)
        }
      }
    },
    validacionPasos: {
      deep: true,
      handler () {
        if (this.step === 1) {
          this.kycEstaValidado = false
        }
        if (this.compradoresCreated && !this.cambiadoData) {
          this.cambiadoData = true
          this.$emit('cambiado', this.cambiadoData)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reservas/validacionDocumentacion/ValidacionDocumentacion.vue